import { Injectable } from "@angular/core";

import { InvalidOperationException } from "../exceptions/exceptions";
import { RestApiQueryParameter } from "../models/backend-rest-api-query-parameter";
import { HttpRequestHeader } from "../models/http-header";

import { LanguageService } from "./language/language.service";

@Injectable({
  providedIn: "root",
})
export class BackendHttpParameterService {
  constructor(private readonly _languageService: LanguageService) {}

  createDefaultBackendHttpHeaders() {
    const acceptLanguage =
      this._languageService.getAcceptLanguageHttpHeaderValue();

    const headers = {
      [HttpRequestHeader.ACCEPT_LANGUAGE]: acceptLanguage,
    };

    return headers;
  }

  addLanguageQueryString(url: URL) {
    if (url.searchParams.has(RestApiQueryParameter.LANGUAGE)) {
      throw new InvalidOperationException(
        `The url '${url}' already contains a query string key with the value '${RestApiQueryParameter.LANGUAGE}'`,
      );
    }

    const language = this._languageService.getLanguage();

    url.searchParams.set(RestApiQueryParameter.LANGUAGE, language);

    return url;
  }
}
